export default __webpack_public_path__ + "static/media/entertainment.f2cf0633.jpg";